import { render, staticRenderFns } from "./WordCloudInput.vue?vue&type=template&id=0ea1a43c&scoped=true&"
import script from "./WordCloudInput.vue?vue&type=script&lang=js&"
export * from "./WordCloudInput.vue?vue&type=script&lang=js&"
import style0 from "./WordCloudInput.vue?vue&type=style&index=0&id=0ea1a43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea1a43c",
  null
  
)

export default component.exports